import { jwtDecode } from 'jwt-decode';

declare const abp: any;

// Function to check if the token has expired
export const isTokenExpired = () => {
  const token = abp.auth.getToken();

  if (!token) return true; // Token is missing or invalid

  try {
    const decodedToken = jwtDecode(token);
    if (!decodedToken) return true;

    const currentTime = Date.now() / 1000; // Current time in seconds
    return decodedToken?.exp !== undefined && decodedToken.exp < currentTime;
  } catch (error) {
    return true; // Error decoding the token implies it might be invalid or expired
  }
};
